<template>
  <section >
    <el-form
      ref="form"
      :model="formData"
      :rules="rules">
      <div class="flex flex-align-center">

        <div class="flex-sb__72">
          <div class="form-item form-half">
            <span>中文</span>
          </div>
          <div class="form-item form-half">
            <span>English</span>
          </div>
        </div>
      </div>
      <div
        ref="sortableList"
        class="sortable-list">
        <div
          v-for="(item,index) in content"
          :key="item.template_id"
          class="flex  flex-align-center drag-container">
          <div class="flex-sb__72">
            <div class="form-item form-half">
              <el-form-item
                :ref="`content.${index}.content_hk`"
                :rules="rules.input"
                :prop="`content.${index}.content_hk`"
              >
                <v-input
                  v-model="item.content_hk"
                  type="textarea"
                  :rows="4"
                />
              </el-form-item>
            </div>
            <div class="form-item form-half">

              <el-form-item
                :ref="`content.${index}.content_en`"
                :rules="rules.input"
                :prop="`content.${index}.content_en`"
              >
                <v-input
                  v-model="item.content_en"
                  type="textarea"
                  :rows="4"
                />
              </el-form-item>
            </div>
          </div>
          <span class="flex mg-l-20">
            <span
              class="icon mg-r-20">
              <font-awesome-icon
                v-if="formData.content.length>1"
                icon="trash-alt"
                class="icon_del"
                @click="handleDel(index)" />
            </span>
            <span
              class="icon drag-handle">
              <font-awesome-icon
                class="drag-handle"
                icon="grip-lines" />
            </span>
          </span>
        </div>
      </div>
      <div class="flex flex-sb-center">
        <span>
          <v-button
            gray
            @click="handleAdd">Add New Template</v-button>
        </span>
        <span class="flex ">
          <v-button
            gray
            @click="handleCancel">Cancel</v-button>
          <v-button
            green
            class="mg-l-15"
            @click="handleSave">Save</v-button>
        </span>
      </div>
    </el-form>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {getEnquiryTemplateList,saveEnquiryTemplate} from '@api/enquiry'
import Sortable from 'sortablejs'
export default {
  name: 'enquiry-message-edit',
  mixins: [MixinOptions,MixinRules],
  data(){
    return{
      old_index: null,
      sortable: {},
      template_id:1,
      formData:{
        content:[
          {
            content_hk:'',
            content_en:'',
            template_id:0
          }
        ]
      }
    }
  },
  computed:{
    content(){
      let {content=[]} = this.formData
      return content
    }
  },
  mounted() {
    this.network().getEnquiryTemplateList()
    this.scrollTo(0)
    this.initSortable()
  },
  methods:{
    initSortable() {
      Sortable.create(this.$refs.sortableList, {
        animation: 150,
        handle: '.drag-handle',
        onEnd: (evt) => {
          this.handleSort(evt)
        },
      })
    },
    handleSort(evt) {
      let data = JSON.parse(JSON.stringify(this.formData.content))
      this.formData.content = [{}]
      const movedItem = data.splice(evt.oldIndex, 1)[0]
      data.splice(evt.newIndex, 0, movedItem)
      this.formData.content = data
    },
    handleDel(index){
      this.formData.content.splice(index,1)
      let {content} = this.formData||{}

    },
    handleAdd(){
      this.template_id += 1
      let obj = {
        content_hk:'',
        content_en:'',
        template_id:this.template_id
      }
      let item = JSON.parse(JSON.stringify(obj))
      this.formData.content.push(item)
    },
    handleSave(){
      this.$refs.form.validate( (valid) => {
        if (valid) {
          // 額外參數
          this.network().saveEnquiryTemplate()
        }

      })
    },
    handleCancel(){
      this.$emit('cancel')
    },
    network() {
      return {
        getEnquiryTemplateList: async () => {
          const {data} = await getEnquiryTemplateList()
          let {content} = data
          if(content){
            let arr = content.reduce((res,item,index)=>{
              this.template_id += 1
              res.push({...item,template_id:index})
              return res
            },[])
            this.formData.content  =arr
          }
        },
        saveEnquiryTemplate: async () => {
          const {data} = await saveEnquiryTemplate({...this.formData})
          await this.network().getEnquiryTemplateList()
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
.icon_del{
  color: rgba(203, 36, 49, 1);
}
.icon{
  font-size: 16px;
}
.drag-handle{
  cursor: move;
}
.mg-r-20{
  margin-right: 20px;
}
.flex-sb__72{
  display: flex;
  justify-content: space-between;
  .form-half{
    width: calc(50% - 5px);
  }
  width: calc(100% - 72px);
}
</style>
